export default __webpack_public_path__ + "770fcdeb306c0ed601e1253961c7bcdb.pdf";